<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon
            v-if="this.unavailablePeriodTypes.length == 0"
            class="load-rotate"
            >{{ formIcon }}
          </md-icon>
          <md-icon v-if="this.unavailablePeriodTypes.length != 0">{{
            formIcon
          }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="label"
          rules="required|min:2|max:24"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Label</label>
            <md-input v-model="label" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="type_id"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>type</label>
            <md-select
              v-model="type_id"
              name="type_id"
              id="type_id"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in fieldTypesDropDown"
                :value="index"
                :key="index"
                >{{ orderOption }}
              </md-option>
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="startDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Start datum</label>
            <md-datepicker
              v-model="startDate"
              name="startDate"
              id="startDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="stopDate"
          :rules="{
            required: false,
            regex: /^([0-2]{1}[0-9]{1}|3[0-1]{1})-(0[0-9]{1}|1[0-2]{1})-20[0-9]{2}$/
          }"
          v-slot="{ passed, failed }"
        >
          <md-field
            class="md-datepicker"
            :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            :disabled="requesting"
          >
            <label>Stop datum</label>
            <md-datepicker
              v-model="stopDate"
              :md-model-type="String"
              md-immediately
            />

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="recurringYearly"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Jaarlijks herhalend</label>
            <md-select
              v-model="recurringYearly"
              name="recurringYearly"
              id="recurringYearly"
              required
              :disabled="requesting"
            >
              <md-option :value="0" :key="0">Nee </md-option>
              <md-option :value="1" :key="1">Ja </md-option>
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug
        </md-button>
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      requesting: false,
      unavailablePeriodTypes: [],
      label: "",
      type_id: "",
      startDate: "",
      stopDate: "",
      recurringYearly: 0,
      touched: {
        label: false,
        type_id: false,
        startDate: false,
        stopDate: false,
        recurringYearly: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];

      this.loadUnavailablePeriodTypes();
      if (this.$route.params.id !== undefined) {
        this.loadUnavailablePeriod(this.$route.params.id);
      } else {
        this.name = "";
        this.type_id = "";
        this.startDate = "";
        this.stopDate = "";
        this.recurringYearly = 0;

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "drivers/unavailableperiods/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            user_id: this.$route.params.userId,
            type_id: this.type_id,
            startDate: this.formatDateBack(this.startDate),
            stopDate: this.formatDateBack(this.stopDate),
            recurringYearly: this.recurringYearly,
            label: this.label
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Chauffeur niet beschikbare periode succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur periode",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadUnavailablePeriod(id) {
      this.requesting = true;
      this.$http
        .get(this.$apiBaseUrl + "drivers/unavailableperiods/" + id)
        .then(
          response => {
            this.label = response.data.unavailablePeriod.label;
            this.type_id = response.data.unavailablePeriod.type_id;
            this.startDate = this.formatDate(
              response.data.unavailablePeriod.startDate
            );
            this.stopDate = this.formatDate(
              response.data.unavailablePeriod.stopDate
            );
            this.recurringYearly =
              response.data.unavailablePeriod.recurringYearly;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van chauffeur periode", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadUnavailablePeriodTypes() {
      this.addButtonDisabled = true;
      this.$http
        .get(this.$apiBaseUrl + "drivers/unavailableperiods/types/")
        .then(
          response => {
            this.unavailablePeriodTypes = response.data.unavailablePeriodTypes;
          },
          response => {
            if (response.status === 403) {
              this.addButtonDisabled = false;
              this.notifyVue(
                "U heeft geen rechten voor het beheren van Chauffeur niet-beschikbare perioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    resetTouched() {
      this.touched.label = false;
      this.touched.type_id = false;
      this.touched.startDate = false;
      this.touched.stopDate = false;
      this.touched.recurringYearly = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  watch: {
    label() {
      if (!this.requesting) {
        this.touched.label = true;
      }
    },
    startDate() {
      if (!this.requesting) {
        this.touched.startDate = true;
      }
    },
    stopDate() {
      if (!this.requesting) {
        this.touched.stopDate = true;
      }
    },
    recurringYearly() {
      if (!this.requesting) {
        this.touched.recurringYearly = true;
      }
    },
    type_id() {
      if (!this.requesting) {
        this.touched.type_id = true;
      }
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Chauffeur niet beschikbare periode bewerken";
      }
      return "Chauffeur niet beschikbare periode toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "article";
      }
      return "article";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    fieldTypesDropDown: function() {
      let data = {};
      for (let i in this.unavailablePeriodTypes) {
        data[
          this.unavailablePeriodTypes[i]["id"]
        ] = this.unavailablePeriodTypes[i]["label"];
      }

      return data;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;

  &:after {
    bottom: 20px;
  }
}
</style>
